import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import styled from 'react-emotion';

const Heading = styled('h1')({
  fontFamily: 'scriptinaregular',
  fontSize: '48px',
  lineHeight: '70px',
  fontWeight: 'normal',
  margin: 0,
  marginTop: '-10px',
  padding: 0,
  textAlign: 'center',
}, ({ theme }) => ({
  ...theme.media.smallMobile({
    fontSize: '32px',
    lineHeight: '60px',
    fontWeight: 'bold',
  }),
  ...theme.media.grid({
    fontSize: '72px',
    textAlign: 'left',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginTop: 0,
    height: '120px',
    overflow: 'hidden',
    ...theme.media.shortScreen({
      height: '80px',
    }),
  }),
  ...theme.media.notMobile({
    ...theme.media.shortScreen({
      fontSize: '40px',
      marginTop: '-10px',
    }),
  }),
}));

const Link = styled(ReactLink)({
    textDecoration: 'none',
}, ({theme}) => ({
    color: theme.link,
    ':hover': {
      color: theme.link,
    },
  })
);

export default () => (
  <Heading>
    <Link to="/">Creative Corsetry</Link>
  </Heading>
);



// WEBPACK FOOTER //
// ./src/structure/header/header.js